<template>
	<div class="global-slider-container">
		<div :class='`slider-${componentParams.template}`'>
			<template v-if='componentParams.template == "default"'>
				<slider-default :items='items' @updated='renderOwl'></slider-default>
			</template>

			<template v-else-if='componentParams.template == "mainSlider"'>
				<slider-main :items='items' @updated='renderOwl'></slider-main>
			</template>

			<template v-else-if='componentParams.template == "mainSlider2"'>
				<slider-main2 :items='items' @updated='renderOwl'></slider-main2>
			</template>

			<template v-else-if='componentParams.template == "catalogVueslider"'>
				<slider-catalog :items='items' @updated='renderOwl'></slider-catalog>
			</template>

			<template v-else-if='componentParams.template == "lowCost"'>
				<slider-lowcost :items='items' @updated='renderOwl'></slider-lowcost>
			</template>

			<template v-else-if='componentParams.template == "detailPhoto"'>
				<slider-detail :items='items' @updated='renderOwl'></slider-detail>
			</template>

			<!--<template v-else-if='componentParams.template == "detailPhoto2"'>-->
				<!--<slider-detail2 :items='items' @updated='renderOwl'></slider-detail2>-->
			<!--</template>-->

			<template v-else-if='componentParams.template == "photo2"'>
				<slider-photo2 :items='items' @updated='renderOwl'></slider-photo2>
			</template>

			<template v-else-if='componentParams.template == "otherNews"'>
				<slider-otherNews :items='items' @updated='renderOwl'></slider-otherNews>
			</template>

			<template v-else-if='componentParams.template == "lowCost2"'>
				<slider-other-stock :items='items' @updated='renderOwl'></slider-other-stock>
			</template>

			<template v-else-if='componentParams.template == "stock2"'>
				<slider-stock2 :items='items' @updated='renderOwl'></slider-stock2>
			</template>

			<template v-else-if='componentParams.template == "stockProduct"'>
				<slider-stockp-product :items='items' @updated='renderOwl'></slider-stockp-product>
			</template>

			<template v-else-if='componentParams.template == "lastProject"'>
				<slider-lastproject :items='items' @updated='renderOwl'></slider-lastproject>
			</template>

			<template v-else-if='componentParams.template == "catalogVuesliderToSections"'>
				<slider-catalog-to-section :sliderParams="this.dataParamsFromJson.sliderParams" :items='items' @updated='renderOwl'></slider-catalog-to-section>
			</template>

			<template v-else-if='componentParams.template == "swimSlider"'>
				<slider-swim :items='items' @updated='renderOwl'></slider-swim>
			</template>

			<template v-else>
				Unknown slider template: <b>{{ componentParams.template }}</b>
			</template>
		</div>
	</div>
</template>

<script>
require('__scss/owl.carousel.scss');
require('owl.carousel');
module.exports = {
	props: {
		dataParams: {
			type: String,
			required: true
		},
		dataStaticParams: {
			type: String,
			required: false
		},
	},

	components: {
		'slider-default': require('./sliders/default.vue'),
		'slider-catalog': require('./sliders/catalogVueslider.vue'),
		'slider-catalog-to-section': require('./sliders/catalogVuesliderToSections.vue'),
		'slider-lowcost': require('./sliders/lowCost.vue'),
		'slider-photo2': require('./sliders/slider-photo2.vue'),
		'slider-otherNews': require('./sliders/slider-otherNews.vue'),

		'slider-detail': require('./sliders/detailPhoto.vue'),

		'slider-other-stock': require('./sliders/otherStock.vue'),
		'slider-stock2': require('./sliders/lowCost2.vue'),
		'slider-stockp-product': require('./sliders/stock-product.vue'),
		'slider-lastproject': require('./sliders/lastProject.vue'),
		'slider-main': require('./sliders/mainSlider.vue'),
		'slider-main2': require('./sliders/main-slider-v2.vue'),
		'slider-swim': require('./sliders/swimSlider.vue'),
	},

	data () {
		return {
			api_response: {},
			items: [],
			dataParamsFromJson: {}
		}
	},

	computed: {
		componentParams() {
			try {
				let str = JSON.parse(this.dataParams.replace(/'/g, '"'));
				return str;
			} catch (err) {
				console.error(err)
			}

		},
		staticParams() {
			try {
				let str2 = this.dataStaticParams.replace(/'/g, '"');
				return JSON.parse(str2);
			} catch(err) {
				console.error(err);
			}
		}
		// items() {
		// 	return this.api_response ? this.api_response.items : [];
		// }
	},

	watch: {
		api_response() {
			this.items = this.api_response.items;
		}
	},

	methods: {
		loadAPI(){
			if(this.dataStaticParams) {
				this.items = this.staticParams;
				this.locked = false;
			}else{
				let method = this.componentParams.method;
				let url = this.componentParams.url;
				let custom_request = this.componentParams.request;

				let options = {
					responseType: 'json'
				}

				if (method && method.toLowerCase() == 'post') {
					options.emulateJSON = true;
					this.$http[method](url, custom_request, options).then(success).catch(error);
				} else if(method && method.toLowerCase() == 'get') {
					options.params = custom_request;
					this.$http[method](url, options).then(success).catch(error);
				} else if (this.componentParams.api_response) {
					this.api_response = this.componentParams.api_response;
				}

				function success(response) {
					// console.log(response)
					this.api_response = response.body.api_response;
				}

				function error(err) {
					console.log(err);
				}
			}
		},
		renderOwl(payload) {
			$(this.$el).find('.owl-carousel').trigger('destroy.owl.carousel');
			$(this.$el).find('.owl-carousel .owl-stage').remove();
			$(this.$el).find('.owl-carousel .owl-item').remove();
			$(this.$el).find('.owl-carousel').owlCarousel(payload.owlSettings);
		}
	},

	mounted() {
		this.loadAPI();

		$(document).on('refreshSlider', () => {
			this.loadAPI();
			$(document).trigger('updateSlider');
		});
		try {
			this.dataParamsFromJson = JSON.parse(this.dataParams.replace(/'/g, '"'));
		} catch (err) {
			console.log(err);
		}

	}

	// mounted() {
	// 	const success = response => {
	// 		// console.log(response.body);
	// 		this.api_response = response.body ? response.body.api_response : {};
	// 	}
	//
	// 	const error = error => {
	// 		console.log(error);
	// 	}
	//
	// 	let method = this.componentParams.method;
	// 	let url = this.componentParams.url;
	// 	let custom_request = this.componentParams.request;
	//
	// 	let options = {
	// 		responseType: 'json'
	// 	}
	//
	// 	if(method.toLowerCase() == 'post') {
	// 		options.body = custom_request
	// 	}
	// 	else if(method.toLowerCase() == 'get') {
	// 		options.params = custom_request
	// 	}
	//
	// 	this.$http[method](url, options)
	// 		.then(response => {
	// 			// console.log(response);
	// 			this.api_response = response.body ? response.body.api_response : {};
	// 		})
	// 		.catch(err => {
	// 			console.log(err);
	// 		});
	// }
}
</script>

<style lang="scss">
@import "scss/wanted";

</style>



// WEBPACK FOOTER //
// Slider.vue?3bf16a66